<template>
  <div class="container">
    <AudioIcon />
    <LevelStart :title="title" :name="name" :forwardPath="forwardPath" />
  </div>
</template>

<script>
import { tLevel1 } from '@game/utils';
import LevelStart from '@game/LevelStart.vue';
import { audioMixinLevel1 } from '@game/mixins/audioMixin.js';

export default {
  name: 'Scene0',
  mixins: [audioMixinLevel1],
  components: {
    LevelStart
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'LevelSelection') {
      this.$audioManager.stopAll();
    }
    next()
  },
  data() {
    return {
      title: tLevel1('scene0.title'),
      name: tLevel1('scene0.name'),
      forwardPath: '/game/level-1/scene-1',
    }
  },
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;

  /* animation */
  position: absolute;
}
</style>